<template>
  <l-feature-group name="us-counties">
    <l-geo-json
      :geojson="usCounties"
      :options="usCountiesOptions"
      :options-style="usCountiesStyle"
      />

    <l-feature-group name="us-counties-wrapped" v-if="wrappedMarkers">
      <l-geo-json
        :geojson="usCounties"
        :options="usCountiesOptionsLeft"
        :options-style="usCountiesStyle"
        />
      
      <l-geo-json
        :geojson="usCounties"
        :options="usCountiesOptionsRight"
        :options-style="usCountiesStyle"
        />
    </l-feature-group>
  </l-feature-group>
</template>

<script>
  console.log("import usCountiesData started")
  import usCountiesData from '@/assets/json-files/gz_2010_us_050_00_5m_us_500k_ca.json'

  export default {
    props: ['wrappedMarkers', 'usCountiesOptions', 'usCountiesOptionsLeft', 'usCountiesOptionsRight', 'usCountiesStyle'],
    data: function() {
      console.log("usCountiesData import finished")
      return {
        usCounties: usCountiesData,
      }
    }
  }
</script>
